var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "article_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 22.25H9C3.57 22.25 1.25 19.93 1.25 14.5V8.5C1.25 3.07 3.57 0.75 9 0.75H15C20.43 0.75 22.75 3.07 22.75 8.5V14.5C22.75 19.93 20.43 22.25 15 22.25ZM9 2.25C4.39 2.25 2.75 3.89 2.75 8.5V14.5C2.75 19.11 4.39 20.75 9 20.75H15C19.61 20.75 21.25 19.11 21.25 14.5V8.5C21.25 3.89 19.61 2.25 15 2.25H9Z",
    fill: "#000D14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.75 9.25H8.25C7.84 9.25 7.5 8.91 7.5 8.5C7.5 8.09 7.84 7.75 8.25 7.75H15.75C16.16 7.75 16.5 8.09 16.5 8.5C16.5 8.91 16.16 9.25 15.75 9.25Z",
    fill: "#000D14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.75 15.25H8.25C7.84 15.25 7.5 14.91 7.5 14.5C7.5 14.09 7.84 13.75 8.25 13.75H15.75C16.16 13.75 16.5 14.09 16.5 14.5C16.5 14.91 16.16 15.25 15.75 15.25Z",
    fill: "#000D14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle1);
export default __webpack_public_path__ + "static/media/article_1.53e8748df66f09751cfed09f76e6b581.svg";
export { ForwardRef as ReactComponent };